import React from "react"
import { useSearchParams } from "react-router-dom"
import { ApplePayButton } from "@tap-payments/apple-pay-button"

export default function ApplePay() {
  const [searchParams] = useSearchParams()
  const publickey = searchParams.get("publickey") as string
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw"
      }}
    >
      <ApplePayButton
        debug
        operator={{
          publicKey: publickey ?? "pk_test_Vlk842B1EA7tDN5QbrfGjYzh"
        }}
        merchant={{
          id: ""
        }}
        scope={'taptoken' as any}
        acceptance={{
          supportedSchemes: ["AMEX", "MADA", "VISA", "MASTERCARD"] as any
        }}
        order={{
          currency: "KWD",
          amount: Number((1).toFixed(2))!
        }}
        customer={{
          name: [
            {
              lang: "en" as any,
              first: "ahmed",
              last: "Sharkawy"
            }
          ],
          contact: {
            email: "a.elsharkawy@tap.company",
            phone: {
              countryCode: "20",
              number: "1099137773"
            }
          }
        }}
        onReady={() => {
          console.log("onReady")
        }}
        onSuccess={(data) => {
          console.log("onSuccess", data)
        }}
        onCancel={() => {
          console.log("onCancel")
        }}
        onError={(error) => {
          console.log("onError", error)
        }}
        onClick={(d) => {
          console.log("onClick", d)
        }}
      />
    </div>
  )
}
